<template>
    <div style="display: flex;justify-content: space-between">
      <div>
        <el-button type="primary" :disabled="loading" @click="openDialog">选图</el-button>
        <el-select placeholder="新建国家分组" style="margin-left: 4px" :disabled="loading" @change="addCountry" filterable>
          <el-option v-for="c in $root.country_list" :value="c.code" :disabled="countries.includes(c.code)"
                     :label="c.en_name + ' (' + c.code + ')'"></el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="form.platform" :disabled="loading" @change="formatData" placeholder="平台" filterable
                   clearable style="width: 150px; margin-right: 3px">
          <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
        </el-select>
        <el-select v-model="form.country" :disabled="loading" @change="formatData" placeholder="全球">
          <el-option value="GLOBAL" label="GLOBAL"></el-option>
          <el-option v-for="c in countries" :value="c" :label="c"></el-option>
        </el-select>
        <el-select v-model="form.label" :disabled="loading" @change="formatData" style="width: 240px">
          <el-option v-for="l in labels" :value="l" :label="`方案${l}`"></el-option>
        </el-select>
        <el-button v-if="has_feature_rookie_apply" type="danger" :disabled="loading" @click="openApplyDialog" style="margin-left: 5px">应用</el-button>
      </div>
    </div>
    <RookieSortableBoard
        :days="displayData"
        :cdn-url="$root.cdn_url"
        :loading="loading"
        @reorder="onRookieReorder"
        @remove="remove"
    />

    <el-table style="margin-top: 10px" v-loading="loading" :data="rookieFilter">
      <el-table-column label="预览图" prop="prefix" width="230">
        <template #default="scope">
          <el-image lazy :src="`${$root.cdn_url}/${scope.row.thumbnail}`"
                    style="width: 150px"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="ID" prop="image_id" width="180"></el-table-column>
      <el-table-column label="激励视频" width="150">
        <template #default="scope">
          <el-tag v-if="scope.row.video">{{"Yes"}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="动图" width="180">
        <template #default="scope">
          <video v-if="scope.row.animation" :src="`${$root.cdn_url}/${scope.row.animation}`" controls muted
                 style="width: 150px"></video>
        </template>
      </el-table-column>
      <el-table-column label="天数" prop="day" width="180">
        <template #default="scope">
          <el-input-number v-model="scope.row.day" :disabled="loading"  @change="updateRookie(scope.row, true)"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="上线时间" prop="online_date" width="200"></el-table-column>
    </el-table>

    <el-dialog v-model="dialog_opened" :before-close="reset" width="80%">
        <el-form :model="form" label-width="100px" ref="form">
            <el-form-item label="天数" prop="day" :rules="[{required: true, message: '输入天数', type: 'number'}]">
                <el-input-number v-model="form.day" :disabled="loading"></el-input-number>
            </el-form-item>
            <el-form-item label="图片" prop="images" :rules="[{required: true, message: '请选择图片'}]">
              <template v-for="image in form.images">
                <div style="display: inline-block; position: relative; margin-right: 5px">
                  <el-image style="width: 160px" :src="`${$root.cdn_url}/${image.thumbnail}`"></el-image>
                  <el-tag v-if="image.animation" type="success" style="position: absolute; top: 5px; left: 5px">动图</el-tag>
                </div>
              </template>
            </el-form-item>
        </el-form>
        <div>
            <el-select :disabled="loading" v-model="query.category" clearable filterable style="width: 200px"
                       placeholder="分类">
                <el-option v-for="c in category_list" :label="`${c.i18n_name.EN}(${c.i18n_name.ZH_HANS})`"
                           :value="c.key"></el-option>
            </el-select>
            <el-select :disabled="loading" v-model="query.video" clearable style="width: 100px" placeholder="激励视频">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
            </el-select>
            <el-select :disabled="loading" v-model="query.is_animated" clearable style="width: 120px" placeholder="是否动图">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
            </el-select>
            <el-select :disabled="loading" v-model="query.online" clearable style="width: 200px" placeholder="已上线图片">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
            </el-select>
            <el-input v-model="query.id" placeholder="ID" style="width: 220px"></el-input>
            <el-button type="success" :loading="loading" @click="fetchImages(1)">查询</el-button>
        </div>
        <el-table :data="image_list" v-loading="loading" style="margin-top: 10px">
            <el-table-column label="ID" prop="id" width="250">
                <template #default="scope">
                    <div>{{ scope.row.id }}</div>
                    <div style="text-align: center">
                        <a :href="`${$root.cdn_url}/${scope.row.resource}`" target="_blank">查看原图</a>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="缩略图" prop="thumbnail" width="100">
                <template #default="scope">
                    <el-image :src="`${$root.cdn_url}/${scope.row.thumbnail}`" lazy style="width: 90px"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="动图" prop="animation" width="180">
                <template #default="scope">
                    <video v-if="scope.row.animation" :src="`${$root.cdn_url}/${scope.row.animation}`" controls muted
                           style="width: 150px"></video>
                </template>
            </el-table-column>
            <el-table-column label="模块" prop="module" width="100">
                <template #default="scope">
                    {{ $root.image_module_enum[scope.row.module] }}
                </template>
            </el-table-column>
            <el-table-column label="分类" prop="categories" width="200">
                <template #default="scope">
                    <template v-for="key in scope.row.categories">
                        <template v-for="c in category_list">
                            <el-tag v-if="c.key === key">{{ c.i18n_name.EN }}</el-tag>
                        </template>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="视频" prop="video" width="100">
                <template #default="scope">
                    {{ scope.row.video ? '是' : '' }}
                </template>
            </el-table-column>
            <el-table-column label="上线时间" prop="online_date" width="150"></el-table-column>
            <el-table-column label="操作" width="200">
                <template #default="scope">
<!--                  <el-button type="primary" @click="addImage(scope.row)" :disabled="loading">添加</el-button>-->
                  <el-button type="primary" @click="addImage(scope.row)" size="small" :disabled="loading || scope.row.added">
                    {{ scope.row.added ? '已添加' : '添加' }} </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" :total="total" @current-change="fetchImages"
                       :page-size="query.limit"></el-pagination>
        <template #footer>
            <el-button type="primary" :loading="loading" @click="reset" text>取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>

    <el-dialog v-model="dialog_opened_apply" width="30%" title="应用新手图">
      <el-form label-width="180px">
        <el-form-item label="选择要应用到哪些方案：">
          <el-checkbox-group v-model="this.form.target_labels" :disabled="loading">
            <el-checkbox v-for="i in this.labels" :key="i" :label="i">{{ `方案${i}` }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="选择要应用的国家：">
          <el-select v-model="form.target_country" :disabled="loading" placeholder="全球" filterable>
            <el-option v-for="c in countries" :value="c" :label="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择要应用的平台：">
          <el-select v-model="form.target_platform" :disabled="loading" placeholder="Android" filterable>
            <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-row style="justify-content: flex-end; margin-top: 10px">
        <el-button @click="reset()"  :loading="loading">取消</el-button>
        <el-button @click="applyRookie()"  type="primary" :loading="loading">确认</el-button>
      </el-row>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import RookieSortableBoard from './rookie/RookieSortableBoard.vue'
import {has_feature_rookie_apply} from "../libs/permission";
import {getProduct} from "../libs/app.ts";

export default {
    name: "Rookie",
    components: {RookieSortableBoard},
    data() {
        return {
            loading: false, data: [], label: [], labels: [0, 1, 2], image: null, countries: [],
            dialog_opened: false, rookie: [], category_list: [],
            dialog_opened_apply: false, image_list: [],  total: 0, page: 1, rookie_set: new Set(),
            form: {
                label: 0,
                day: 0,
                // image_id: '',
                images: [],
                country: "GLOBAL",
                platform: "ios",
                target_labels: [0, 1, 2],
                target_country: null,
                target_platform: null,
            },
            query: {
                module: 1,
                online: true,
                skip: 0,
                limit: 10,
                video: null,
                is_animated: null,
                product: getProduct().key,
            },
        }
    },
    methods: {
      has_feature_rookie_apply,
        init() {
            this.loading = true;
            return axios.get(`/cms/v1/rookie`).then(res => {
                this.rookie = res.data.data.rookieList;
            }).then(_ => {
                this.formatData();
            }).catch(err => {
                this.$message.error(err?.response?.data?.status?.message || '新手图数据加载失败，请刷新重试');
            }).finally(() => {
                this.loading = false;
            })
        },
        openDialog() {
            this.dialog_opened = true;
            this.form.images = []
            this.form.day = 0
            this.query.id = '';
            this.fetchImages(1);
        },
        fetchImages(page) {
          this.query.skip = (page - 1) * this.query.limit;
          this.page = page
          this.loading = true;
          axios.get(`/cms/v1/image`, {params: this.query}).then(res => {
            this.image_list = res.data.data.imageList;
            this.total = res.data.data.total;
            this.loading = false;
            this.refreshAdded();
          })
        },
        openApplyDialog() {
          this.dialog_opened_apply = true;
          this.form.target_labels = [0,1,2];
          this.form.target_country = this.form.country;
          this.form.target_platform = this.form.platform
        },
        formatData() {
            this.data = [];
            this.rookie_set = new Set()
            this.rookie.forEach(r => {
                if (!r.label) {
                  r.label = 0
                }
                if (!r.platform) {
                  r.platform = "android"
                }
                if (!r.country) {
                  r.country = "GLOBAL"
                }
                if (!this.countries.includes(r.country) && r.country !== "GLOBAL") {
                  this.countries.push(r.country);
                }
                // if (!this.label.includes(r.label)) {
                //     this.label.push(r.label);
                // }
                if (r.label === this.form.label && r.country === this.form.country && r.platform === this.form.platform) {
                    this.rookie_set.add(r.image_id)
                    if (!this.data[r.day]) {
                        this.data[r.day] = {day: r.day, images: []}
                    }
                    this.data[r.day].images.push(r);
                }
            });
            this.data.forEach(d => {
                d.images.sort(function (a, b) {
                    return a.sort - b.sort;
                })
            })
            this.refreshAdded();
        },
        refreshAdded() {
          this.image_list.forEach(image => {
            image.added = false;
          });
          this.image_list.forEach(image => {
            image.added = this.rookie_set.has(image.id);
          });
        },
        reset() {
            if(this.$refs.form) {
              this.$refs.form.resetFields();
            }
            // this.image = null;
            this.form.images = [];
            this.dialog_opened = this.dialog_opened_apply =this.loading = false;
            this.refreshAdded()
        },
        submit() {
            // this.$refs.form.validate(valid => {
            //     if (valid) {
            //         this.loading = true;
            //         axios.post(`/cms/v1/rookie`, this.form).then(res => {
            //             this.rookie.push(res.data.data);
            //             this.init();
            //             this.reset();
            //         });
            //     }
            // })
            this.$refs.form.validate(valid => {
              if (valid) {
                this.loading = true;
                const reqs = [];
                this.form.images.forEach(i => {
                  const data = {day: this.form.day, label: this.form.label, country: this.form.country, image_id: i.id,
                    platform: this.form.platform};
                  reqs.push(axios.post(`/cms/v1/rookie`, data).then(res => {
                    this.rookie.push(res.data.data);
                  }));
                });
                axios.all(reqs).then(_ => {
                  this.init();
                  this.reset();
                })
              }
            })
        },
        remove(row) {
            this.loading = true;
            axios.delete(`/cms/v1/rookie/${row.id}`).then(res => {
                this.init()
            });
        },
        addImage(image) {
          image.added = true
          this.form.images.push(image);
        },
        onRookieReorder({ day, from, to }) {
            const dayData = this.data[day];
            if (!dayData) {
                return;
            }
            const images = dayData.images;
            const [item] = images.splice(from, 1);
            images.splice(to, 0, item);
            this.resort(images);
        },
        resort(images) {
            const sort = images.map((i, index) => {
                i.sort = index;
                return i.id;
            });
            axios.post(`/cms/v1/sort/rookie`, { sort }).catch(err => {
                this.$message.error(err?.response?.data?.status?.message || '排序保存失败，请稍后重试');
                this.init();
            });
        },

        // online(row) {
        //     this.image = row;
        //     this.form.image_id = row.id;
        // },
        updateRookie(row, refresh) {
          if(refresh) {
            this.loading = true;
          }
          axios.put(`/cms/v1/rookie`, {
            image_id: row.image_id, day: row.day, platform: this.form.platform,
            label: this.form.label, country: this.form.country}).then(_ => {
            if(refresh) {
              this.loading = false
              this.init();
            }
          })
        },
        applyRookie() {
          this.loading = true;
          axios.post(`/cms/v1/apply/rookie`, {label: this.form.label, country: this.form.country,
            target_labels: this.form.target_labels.join(','), platform: this.form.platform,
            target_country: this.form.target_country, target_platform: this.form.target_platform}).then(_ => {
            this.init();
            this.reset();
          });
        },
        addCountry(country) {
          if (country && !this.countries.includes(country)) {
            this.countries.push(country);
            this.form.country = country;
            this.data = [];
          }
        }
    },

    computed: {
      displayData() {
        return this.data.filter(Boolean);
      },
      rookieFilter() {
        return this.rookie.filter(d => {
          if (!d.label) {
            d.label = 0
          }
          return d.label === this.form.label && d.country === this.form.country && d.platform === this.form.platform;
        })
      },
    },

    mounted() {
        this.loading = true;
        axios.all([
            axios.get('/cms/v1/category').then(res => {
                this.category_list = res.data.data.categoryList;
            }),
        ]).then(_ => {
            this.loading = false;
            this.init();
        })
    },
}
</script>

<style scoped>

.el-select {
  width: 150px;
}

</style>
